import React from "react";
import "./header.style.scss";
import { Link } from "react-router-dom";
import LanguageSwitcher from "./language-switcher.component.js";
import useLanguage from "../redux/use-language.js";

function Header() {
  const { language } = useLanguage();

  const addLang = (s) => {
    return "/" + language + s;
  };

  return (
    <header className="site-header">
      <LanguageSwitcher />
      <nav className="nav-main">
        <div className="nav-item">
          <Link className="menuLink" to={addLang("/")}>
            {language === "ru" ? "ГЛАВНАЯ" : "HOME"}
          </Link>
        </div>
        <div className="nav-item">
          <Link className="menuLink" to={addLang("/history")}>
            {language === "ru" ? "ХРОНОЛОГИЯ" : "HISTORY"}
          </Link>
        </div>
        <div className="nav-item">
          <Link className="menuLink" to={addLang("/list")}>
            {language === "ru" ? "СТРАНЫ" : "COUNTRIES"}
          </Link>
        </div>
        <div className="nav-item">
          <Link className="menuLink" to={addLang("/guides")}>
            {language === "ru" ? "ОБЗОРЫ" : "GUIDES"}
          </Link>
        </div>
        <div className="nav-item">
          <Link className="menuLink" to={addLang("/stats")}>
            {language === "ru" ? "СТАТИСТИКА" : "STATS"}
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default Header;
